import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { TASK_TERM } from "../apiRoutes";

const mutateToggleTaskTerm = async ({ id }: { id: string | number }) => {
	return await axiosAuth.patch(`${TASK_TERM}${id}`);
};

const useToggleTaskTermMutation = (
	queryParams?: UseMutationOptions<
		any,
		Error,
		{
			id: string | number;
		},
		unknown
	>
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: mutateToggleTaskTerm,
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({ queryKey: ["taskTerm"], exact: false });
			queryParams?.onSuccess?.(data, variables, context);
		},
		...queryParams,
	});
};

export default useToggleTaskTermMutation;
